import Breadcrumbs, { type Crumb } from '@/components/feature/Breadcrumbs';

type PageHeroProps = {
  kicker: string;
  title: string;
  description: string;
  crumbs: Crumb[];
};

export default function PageHero({ kicker, title, description, crumbs }: PageHeroProps) {
  return (
    <section className="relative bg-foreground-950 pt-28 md:pt-36 pb-12 md:pb-16 overflow-hidden">
      <div
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=abstract%20dark%20textured%20paper%20and%20ink%20clouds%20with%20a%20thin%20crimson%20light%20line%2C%20high%20contrast%20editorial%20background%2C%20cinematic%20grain%2C%20no%20text&width=1600&height=560&seq=st-inner-banner-2026&orientation=landscape)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/90 to-foreground-950/60"></div>

      <div className="relative z-10 w-full px-5 md:px-8 lg:px-12">
        <Breadcrumbs items={crumbs} />
        <p className="mt-8 font-mono text-xs tracking-[0.32em] uppercase text-accent-400">
          {kicker}
        </p>
        <h1 className="mt-4 font-heading text-3xl md:text-5xl font-black leading-tight text-background-50 max-w-4xl">
          {title}
        </h1>
        <p className="mt-5 text-sm md:text-base leading-relaxed text-background-200 max-w-3xl">
          {description}
        </p>
      </div>
    </section>
  );
}